import { Auth0Profile } from './AuthService';

export const AUTH_SESSION_STATUS = {
  bootstrapping: 'bootstrapping',
  authenticated: 'authenticated',
  renewing: 'renewing',
  degraded: 'degraded',
  reauthenticationRequired: 'reauthentication_required',
  redirectingToLogin: 'redirecting_to_login',
  loggingOut: 'logging_out',
  authenticationError: 'authentication_error',
} as const;

export type AuthSessionStatus = (typeof AUTH_SESSION_STATUS)[keyof typeof AUTH_SESSION_STATUS];

export type AuthRenewalTrigger = 'timer' | 'focus' | 'visibilitychange' | 'online' | 'bootstrap' | '401' | 'manual';

export interface AuthGenerationRecord {
  accessToken: string;
  scope: string;
  profile: Auth0Profile | null;
  issuedAt: number;
  expiresAt: number;
  generationId: string;
}

export interface AuthCoordinatorSnapshot {
  accessToken: string | null;
  scope: string | null;
  profile: Auth0Profile | null;
  issuedAt: number | null;
  expiresAt: number | null;
  generationId: string | null;
  sessionStatus: AuthSessionStatus;
  authenticationReason: string | null;
}
